<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>{{ $t('settings.utilities.title') }}</v-toolbar-title>
    	</v-toolbar>

	    <div class="hasToolbar">
	    	
	    	<div class="switches" white-background>
                <v-list two-line>
                    <v-subheader class="primary-color pt-3">{{ $t('settings.utilities.barcodeLabels') }}</v-subheader>
                    <!-- <v-divider></v-divider> -->
                    <v-list-tile class="padding-right-8" @click="fn_printBarcode">

                        <v-list-tile-action>
                            <v-icon>print</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ $t('settings.utilities.printLabels') }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ $t('settings.utilities.printLabelsDesc') }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                        </v-list-tile-action>

                    </v-list-tile>

                    <v-list-tile class="padding-right-8" @click="fn_barcodeLabelTemplates">

                        <v-list-tile-action>
                            <v-icon>build</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                            <v-list-tile-title>{{ $t('settings.utilities.templates') }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ $t('settings.utilities.templatesDesc') }}</v-list-tile-sub-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                            <v-icon class="primary-color">keyboard_arrow_right</v-icon>
                        </v-list-tile-action>

                    </v-list-tile>
                </v-list>

	    	</div>

	    </div>


	</div>
</template>

<script>

	export default{
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

            fn_printBarcode: function(){
                this.$router.push({path:"/barcode/generator", query:{tagId:this.guidWeb()}});
            },

            fn_designBarcode: function(){
                this.$router.push({path:"/barcode/designer", query:{tagId:this.guidWeb()}});
            },

            fn_barcodeLabelTemplates: function(){
                this.$router.push({path:"/barcode/items", query:{tagId:this.guidWeb()}});
            },		
	  	},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  	}
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/utilities/utilities.vue